<template>
  <div>
    <h6 v-if="profileId == 0" class="heading-small text-muted mb-4">
      Add New Discount {{ discount.name ? " - " + this.discount.name : "" }}
    </h6>
    <h6 v-else-if="profileId != 0 && viewMode" class="heading-small text-muted mb-4">
      View Discount - {{ this.discount.name }}
    </h6>
    <h6 v-else class="heading-small text-muted mb-4">
      Edit Discount - {{ this.discount.name }}
    </h6>

    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <!-- <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
      <b-tab title="Details" active v-on:click="openDetails"></b-tab>
      <b-tab title="History" v-on:click="openHistory">
        <b><label>Created By: </label></b>
        {{ inputCreatedBy }} | {{ inputCreatedAt | dateFilter }}
        <br />
        <b><label>Updated By:</label></b>
        {{ inputUpdatedBy }} | {{ inputUpdatedAt | dateFilter }}
      </b-tab>
    </b-tabs> -->

    <form id="form-proper">
      <div v-if="customFormMode == 1">
        <!-- Normal -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <a-spin :spinning="fetching" tip="Loading...">
             <div> 
                <base-input
                  alternative=""
                  label="Code"
                  placeholder=""
                  v-model="discount.code"
                  input-classes="form-control"
                  :disabled="is_system || viewMode"
                />
                <base-input
                  alternative=""
                  label="Name"
                  placeholder=""
                  v-model="discount.name"
                  input-classes="form-control"
                  :disabled="is_system || viewMode"
                  required
                />
                <base-input
                  alternative=""
                  label="Discount Category"
                  placeholder="Select Discount Category"
                  input-classes="form-control"
                  :disabled="is_system || viewMode"
                  
                >
                  <a-select
                    v-model="discount.discount_category"
                    :disabled="is_system || viewMode"
                  >
                    <a-select-option value="employee_discount">Employee Discount</a-select-option>
                  </a-select>
                </base-input>
                <base-input
                  alternative=""
                  label="Discount Type"
                  placeholder=""
                  input-classes="form-control"
                  :disabled="is_system || viewMode"
                  required
                >
                  <a-select
                    v-model="discount.discount_type"
                    :disabled="is_system || viewMode"
                    defaultValue="OVA"
                  >
                    <a-select-option value="OVA">Overall Discount</a-select-option>
                  </a-select>
                </base-input>
                <base-input
                  alternative=""
                  label="Rate Type"
                  placeholder=""
                  input-classes="form-control"
                  required
                >
                  <a-select
                    v-model="discount.rate_type"
                    :disabled="is_system || viewMode"
                    @change="discount.rate = 0"
                  >
                    <a-select-option value="P">Percentage</a-select-option>
                    <a-select-option value="A">Fixed Amount</a-select-option>
                  </a-select>
                </base-input>
                <base-input
                  alternative=""
                  :label="discount.rate_type == 'P' ? 'Discount Rate' : 'Discount Amount'"
                  placeholder=""
                  input-classes="form-control"
                  required
                >
                  <a-input
                    type="number"
                    v-model="discount.rate"
                    :disabled="is_system || viewMode"
                    :suffix="discount.rate_type == 'P' ? '%' : ''"
                  />
                </base-input>
                <base-input
                  alternative=""
                  label="Minimum Amount Required"
                  placeholder=""
                  input-classes="form-control"
                  required
                >
                  <a-input
                    type="number"
                    v-model="discount.min_amount_requirement"
                    :disabled="is_system || viewMode"
                  />
                </base-input>
                <base-input
                  alternative=""
                  label="Maximum Discount Allowed"
                  placeholder=""
                  input-classes="form-control"
                  required
                >
                  <a-input
                    type="number"
                    v-model="discount.max_discount_amount"
                    :disabled="is_system || viewMode"
                  />
                </base-input>
                <base-input label="Sequence No">
                  <a-input
                    type="number"
                    v-model="discount.sequence_no"
                    :disabled="is_system || viewMode"
                  />
                </base-input>
              </div>
            </a-spin>
          </a-tab-pane>
          <a-tab-pane tab="Advanced" key="2">
            <base-input
              alternative=""
              label="Effectivity Date"
              placeholder=""
              input-classes="form-control"
              >
              <br />
              <small>If no Effectivity Date is set, this discount will be available immediately and indefinitely.</small>
              <br>
              <br>
              <a-range-picker
                v-model="dateRange"
                format="YYYY-MM-DD"
                :placeholder="['Start Date', 'End Date']"
                style="width: 100%"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              alternative=""
              label="Available Days"
              placeholder=""
              input-classes="form-control"
            >
              <br>
              <small>If no days are selected, discount is available for all days of the week.</small>
              <br>
              <br>
              <div
                class="d-flex flex-row flex-wrap justify-content-between align-content-between"
              >
                <div
                  v-for="(option, index) in dayOptions"
                  :key="index"
                  style="width: 120px"
                >
                  <a-checkbox
                    v-if="option.label != ''"
                    :value="option.value"
                    @change="selectDaysAvail(option.value)"
                    :checked="checkedDays.includes(option.value)"
                    :disabled="is_system || viewMode"
                  >
                    {{ option.label }}
                  </a-checkbox>
                </div>
              </div>
            </base-input>
            <base-input
              alternative=""
              label="Sites"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.site_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Sites"
              >
                <a-select-option
                  v-for="option in siteOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Transaction Types"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.transaction_type_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Transaction Types"
              >
                <a-select-option
                  v-for="option in transactionTypeOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Subsegments"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.subsegment_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Subsegments"
              >
                <a-select-option
                  v-for="option in subsegmentOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              label="Allow Supervisor Override"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_supervisor_edit"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Overall Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_ova_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Government Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_gov_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Promo Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_item_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Print Approval Copy"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_print_approval_copy"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Bypass Auto Calculation"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.bypass_discount_recalculation"
                :disabled="is_system || viewMode"
              />
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Select Item" key="3">
            <!-- SELECT ITEMS OPTIONS -->
            <h2 class="card-title">Select Items/Categories</h2>
            <div class="row">
              <div class="col-md-6">
                <base-input>
                  <a-select v-model="include_item" style="width: 100%" :disabled="is_system || viewMode">
                    <a-select-option
                      v-for="option in includeItemOptions"
                      :key="option.key"
                      :value="option.key"
                    >
                      {{ option.value }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <!-- SELECTED ITEMS -->
            <a-tabs v-if="include_item == 2" defaultActiveKey="1">
              <!-- PRODUCT SELECTION TAB -->
              <a-tab-pane key="1">
                <span slot="tab">
                  <span class="numberCircle">Search Product</span>
                </span>

                <div class="row no-gutters d-flex mb-3">
                  <div class="col-md-8">
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-dropdown :text="filterCaption" variant="outline-default">
                          <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                          <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                        </b-dropdown>
                      </template>
                      <b-form-input
                        style="padding:5px; height:44px;"
                        @keypress.enter="handleSearch"
                        v-model="searchTextForFreeItem"
                        :disabled="is_system || viewMode"
                      />
                    </b-input-group>
                  </div>

                  <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <base-button
                      type="default"
                      class="btn btn-sm"
                      style="background-color: #394A5D; color: white;"
                      @click.prevent="addAllFromIncludedList"
                      :disabled="is_system || viewMode"
                    >
                      Add All
                    </base-button>
                  </div>
                  <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <base-dropdown
                      class="ellisis-cont nav-link pr-0 float-right"
                      position="right">

                      <div class="media align-items-center" slot="title">
                        <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                      </div>

                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="toggleUploadProductsDrawer(true)">
                          <i class="fa fa-upload"></i>
                          <span>Import</span>
                        </div>
                      </template>
                    </base-dropdown>
                  </div>
                </div>

                <a-table
                  :columns="productSelectionColumns"
                  :dataSource="selectedItemProductData"
                  :loading="isLoading"
                  :rowKey="record => record.id"
                  bordered
                  size="middle"
                  class="table table-responsive"
                  :pagination="pagination"
                  @change="handleTableChange"
                >
                  <template slot="action" slot-scope="record">
                    <a-button
                      :type="selectedProductItem.includes(record.id) ? 'danger' : 'primary'"
                      size="small"
                      @click="selectIncludeProductItem(record)"
                      :disabled="is_system || viewMode"
                    >
                      {{ selectedProductItem.includes(record.id) ? 'REMOVE' : 'ADD' }}
                    </a-button>
                  </template>
                </a-table>
              </a-tab-pane>
              <!-- SELECTED PRODUCT LIST TAB -->
              <a-tab-pane key="2">
                <span slot="tab">
                  <span class="numberCircle">Selected Product List</span>
                </span>
                <div class="table-responsive mt-3">
                  <fieldset>
                    <a-table
                      v-if="selectedProductItemDetails.length"
                      :columns="productItemColumns"
                      :dataSource="selectedProductItemDetails"
                      :rowKey="record => record.id"
                      bordered
                      size="middle"
                    />
                    <p v-else class="text-center text-muted mt-3">No items added yet.</p>
                  </fieldset>
                </div>
              </a-tab-pane>
            </a-tabs>
            <!-- SELECTED CATEGORIES -->
            <a-tabs v-if="include_item == 3" defaultActiveKey="1">
              <a-tab-pane key="1">
                 <div class="col-md-12" 
                 >
                    <base-input label="Select Category"  :disabled="is_system || viewMode" style="width: 100%; text-align: left;"><br>
                      <a-select
                      mode="multiple"
                       showSearch
                        v-model="inputCategory" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                        :disabled="is_system || viewMode"
                      >
                        <a-select-option v-for="category in categoriesOptions" :value="category.id" :key="category.id">{{category.name}}</a-select-option>
                      </a-select>
                    </base-input>
                    <!-- SELECTED CATEGORY TABLE -->
                    <a-table
                      :key="inputCategory.join(',')"
                      v-if="selectedCategories.length"
                      :columns="categoryColumns"
                      :dataSource="selectedCategories"
                      rowKey="id"
                      size="small"
                    >
                      <template slot="title">
                        <h4 style="margin: 0; font-weight: 600; text-align:center ">Selected Categories</h4>
                      </template>
                      <span slot="action" slot-scope="record">
                        <a-button
                          type="danger"
                          size="small"
                          @click="removeSelectedCategory(record.id)"
                        >
                          Delete
                        </a-button>
                      </span>
                    </a-table>
                    
                </div>
              </a-tab-pane>
            </a-tabs> 

            <!-- ✅ EXCLUDE ITEMS -->
            <a-tabs v-if="include_item == 4" defaultActiveKey="1">
              <!-- PRODUCT SELECTION TAB -->
              <a-tab-pane key="1">
                <span slot="tab">
                  <span class="numberCircle">Search Product</span>
                </span>

                <div class="row no-gutters d-flex mb-3">
                  <div class="col-md-8">
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-dropdown :text="filterCaption" variant="outline-default">
                          <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                          <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                        </b-dropdown>
                      </template>
                      <b-form-input
                        style="padding:5px; height:44px;"
                        @keypress.enter="handleSearch"
                        v-model="searchTextForFreeItem"
                        :disabled="is_system || viewMode"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <base-button
                      type="default"
                      class="btn btn-sm"
                      style="background-color: #394A5D; color: white;"
                      @click.prevent="addAllFromExcludedList"
                      :disabled="is_system || viewMode"
                    >
                      Add All
                    </base-button>
                  </div>
                  <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <base-dropdown
                      class="ellisis-cont nav-link pr-0 float-right"
                      position="right">

                      <div class="media align-items-center" slot="title">
                        <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                      </div>

                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="toggleUploadProductsDrawer(true)">
                          <i class="fa fa-upload"></i>
                          <span>Import</span>
                        </div>
                      </template>
                    </base-dropdown>
                  </div>
                </div>

                <a-table
                  :columns="productSelectionColumns"
                  :dataSource="excludedItemProductData"
                  :loading="isLoading"
                  :rowKey="record => record.id"
                  bordered
                  size="middle"
                  class="table table-responsive"
                  :pagination="pagination"
                  @change="handleTableChange"
                >
                  <template slot="action" slot-scope="record">
                    <a-button
                      :type="excludedProductItems.includes(record.id) ? 'danger' : 'primary'"
                      size="small"
                      @click="selectExcludeProductItem(record)"
                      :disabled="is_system || viewMode"
                    >
                      {{ excludedProductItems.includes(record.id) ? 'REMOVE' : 'EXCLUDE' }}
                    </a-button>
                  </template>
                </a-table>
              </a-tab-pane>
              <!-- EXCLUDED PRODUCT LIST TAB -->
              <a-tab-pane key="2">
                <span slot="tab">
                  <span class="numberCircle">Excluded Product List</span>
                </span>
                <div class="table-responsive mt-3">
                  <fieldset>
                    <a-table
                      v-if="excludedProductItemDetails.length"
                      :columns="productItemColumns"
                      :dataSource="excludedProductItemDetails"
                      :rowKey="record => record.id"
                      bordered
                      size="middle"
                    />
                    <p v-else class="text-center text-muted mt-3">No items added yet.</p>
                  </fieldset>
                </div>
              </a-tab-pane>
            </a-tabs>

            <!-- EXCLUDED CATEGORIES -->
             <a-tabs v-if="include_item == 5" defaultActiveKey="1">
              <a-tab-pane key="1">
                 <div class="col-md-12">
                    <base-input label="Select Excluded Category"  :disabled="is_system || viewMode"><br>
                        <a-select
                        mode="multiple"
                        showSearch
                          v-model="inputExcludedCategory" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                          :disabled="is_system || viewMode"
                        >
                        <a-select-option v-for="category in categoriesOptions" :value="category.id" :key="category.id">{{category.name}}</a-select-option>
                      </a-select>
                    </base-input>
                    <!-- EXCLUDED CATEGORY TABLE -->
                    <a-table
                      :key="inputExcludedCategory.join(',')"
                      v-if="excludeCategories.length"
                      :columns="categoryColumns"
                      :dataSource="excludeCategories"
                      rowKey="id"
                      size="small"
                    >
                      <template slot="title">
                        <h4 style="margin: 0; font-weight: 600; text-align:center ">Excluded Categories</h4>
                      </template>
                      <span slot="action" slot-scope="record">
                        <a-button
                          type="danger"
                          size="small"
                          @click="removeExcludedCategory(record.id)"
                        >
                          Delete
                        </a-button>
                      </span>
                    </a-table>
                    
                </div>
              </a-tab-pane>
            </a-tabs> 

          </a-tab-pane> <!-- END OF a-tab-pane tab="Select Item" key="3" -->
        </a-tabs>
      </div>
      <div v-if="customFormMode == 2">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="color"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Code"
              placeholder=""
              v-model="discount.code"
              input-classes="form-control"
              :disabled="is_system || viewMode"
            />
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="discount.name"
              input-classes="form-control"
              :disabled="is_system || viewMode"
              required
            />
            <base-input
              alternative=""
              label="Discount Category"
              placeholder="Select Discount Category"
              input-classes="form-control"
              :disabled="is_system || viewMode"
              
            >
              <a-select
                v-model="discount.discount_category"
                :disabled="is_system || viewMode"
              >
                <a-select-option value="employee_discount">Employee Discount</a-select-option>
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Discount Type"
              placeholder=""
              input-classes="form-control"
              :disabled="is_system || viewMode"
              required
            >
              <a-select
                v-model="discount.discount_type"
                :disabled="is_system || viewMode"
                defaultValue="OVA"
              >
                <a-select-option value="1">Overall Discount</a-select-option>
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Rate Type"
              placeholder=""
              input-classes="form-control"
              required
            >
              <a-select
                v-model="discount.rate_type"
                :disabled="is_system || viewMode"
                @change="discount.rate = 0"
              >
                <a-select-option value="P">Percentage</a-select-option>
                <a-select-option value="F">Fixed Amount</a-select-option>
              </a-select>
            </base-input>
            <base-input
              alternative=""
              :label="discount.rate_type == 'P' ? 'Discount Rate' : 'Discount Amount'"
              placeholder=""
              input-classes="form-control"
              required
            >
              <a-input
                type="number"
                v-model="discount.rate"
                :disabled="is_system || viewMode"
                :suffix="discount.rate_type == 'P' ? '%' : ''"
              />
            </base-input>
            <base-input
              alternative=""
              label="Minimum Amount Required"
              placeholder=""
              input-classes="form-control"
              required
            >
              <a-input
                type="number"
                v-model="discount.min_amount_requirement"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              alternative=""
              label="Maximum Discount Allowed"
              placeholder=""
              input-classes="form-control"
              required
            >
              <a-input
                type="number"
                v-model="discount.max_discount_amount"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input label="Sequence No">
              <a-input
                type="number"
                v-model="discount.sequence_no"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Supervisor Override"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_supervisor_edit"
                :disabled="is_system || viewMode"
              />
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Advanced" key="2">
            <base-input
              alternative=""
              label="Effectivity Date"
              placeholder=""
              input-classes="form-control"
              >
              <br />
              <small>If no Effectivity Date is set, this discount will be available immediately and indefinitely.</small>
              <br>
              <br>
              <a-range-picker
                v-model="dateRange"
                format="YYYY-MM-DD"
                :placeholder="['Start Date', 'End Date']"
                style="width: 100%"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              alternative=""
              label="Available Days"
              placeholder=""
              input-classes="form-control"
            >
              <br>
              <small>If no days are selected, discount is available for all days of the week.</small>
              <br>
              <br>
              <div
                class="d-flex flex-row flex-wrap justify-content-between align-content-between"
              >
                <div
                  v-for="(option, index) in dayOptions"
                  :key="index"
                  style="width: 120px"
                >
                  <a-checkbox
                    v-if="option.label != ''"
                    :value="option.value"
                    @change="selectDaysAvail(option.value)"
                    :checked="checkedDays.includes(option.value)"
                    :disabled="is_system || viewMode"
                  >
                    {{ option.label }}
                  </a-checkbox>
                </div>
              </div>
            </base-input>
            <base-input
              alternative=""
              label="Sites"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.site_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Sites"
              >
                <a-select-option
                  v-for="option in siteOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Transaction Types"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.transaction_type_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Transaction Types"
              >
                <a-select-option
                  v-for="option in transactionTypeOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              alternative=""
              label="Subsegments"
              placeholder=""
              input-classes="form-control"
            >
              <a-select
                v-model="discount.subsegment_ids"
                mode="multiple"
                allowClear
                :disabled="is_system || viewMode"
                placeholder="All Subsegments"
              >
                <a-select-option
                  v-for="option in subsegmentOptions"
                  :key="option.id"
                  :value="option.id"
                  >{{ option.name }}</a-select-option
                >
              </a-select>
            </base-input>
            <base-input
              label="Allow Supervisor Override"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_supervisor_edit"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Overall Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_ova_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Government Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_gov_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Allow Combination with Promo Discounts"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_allowed_with_item_disc"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Print Approval Copy"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.is_print_approval_copy"
                :disabled="is_system || viewMode"
              />
            </base-input>
            <base-input
              label="Bypass Auto Calculation"
              input-classes="form-control"
              class="d-flex justify-content-between align-items-center"
            >
              <a-switch
                v-model="discount.bypass_discount_recalculation"
                :disabled="is_system || viewMode"
              />
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="4" forceRender>
            <dynamic-form
              :convertedJson="{ mode: customForm.mode, groups: customForm.groups_append }"
              :formSettings="color"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

     <UploadProducts
        ref="uploadProductKey"
        :discountId="discountId"
        :visible="openUploadProductsDrawer"
        :onClose="toggleUploadProductsDrawer"
        :onFileSelected="setUploadFile"  
      />

      <div v-if="!(is_system || viewMode)" class="mt-5">
        <div
          v-if="serverType == 'ho'"
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          "
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            :disabled="isProcessing"
            @click.prevent="update"
          >
            {{ isProcessing ? 'Updating...' : 'Update' }}
          </button>
        </div>
        <div
          v-else
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          "
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ValidateField from "../../components/validateFormUtils.js";
import DynamicForm from "../DynamicForm.vue";
import { mapState, mapActions } from "vuex";
import secureStorage from "../../controllers/secureStorage.js";
import moment from "moment";
import UploadProducts from './Drawers/UploadProducts.vue';
import axios from "axios";

var component_x;

export default {
  components: {
    DynamicForm,
    UploadProducts,
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
    selectedCategories() {
      return this.categoriesOptions.filter(c =>
        this.inputCategory.includes(c.id)
      );
    },
    excludeCategories() {
      return this.categoriesOptions.filter(c =>
        this.inputExcludedCategory.includes(c.id)
      );
    },
  },
  mounted: async function () {
    const systemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Discount?field_name=name",
      null
    );
    const systemModuleId = systemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        systemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }

    // const paymentType = await HTTPRequest.getRequest(this.endPoint.split("/api")[0] + "/api/v1/payment_types/?per_page=200", null)
    // this.payment_types = paymentType;
    // this.sort(this.payment_types);

    component_x = this;

    // loading true
    component_x.fetching = true;

    let sites = await HTTPRequest.getRequest(
      component_x.endPoint + "sites/get_valid_sites",
      null
    );
    component_x.siteOptions = sites;
    component_x.sort(component_x.siteOptions);

    let transaction_types = await HTTPRequest.getRequest(
      component_x.endPoint + "pos_transaction_types/get_valid_pos_transaction_types",
      null
    );
    component_x.transactionTypeOptions = transaction_types;

    // get products and categories
    component_x.getProducts();
    component_x.loadCategories();

    if (component_x.profileId > 0) {
      var discount_data = await HTTPRequest.getRequest(
        component_x.endPoint + "discounts/" + component_x.profileId,
        null,
        "BXI-File"
      );
      if (discount_data == undefined) {
        component_x.$router.go();
      } else {
        if (discount_data["error"] == undefined) {
          component_x.discount = discount_data;
          component_x.is_system = discount_data["is_system"];
          component_x.dateRange = [
            discount_data["start_date"],
            discount_data["end_date"],
          ];
          component_x.checkedDays = discount_data["days_availability"] || [];

          // for ui only
          this.include_item = discount_data["include_item_option"];
          this.inputCategory = discount_data["included_categories"];
          this.inputExcludedCategory = discount_data["excluded_categories"];
          this.discount_category = discount_data["discount_category"] || null;

          if (this.discount.apply_to_all) {
            this.include_item = 1;
          } else if (this.discount.inclusion_type === "I" && this.discount.mapping_type === "P") {
            this.include_item = 2;
            this.selectedProductItem = this.discount.discount_details.map(d => d.value);
            this.selectedProductItemDetails = discount_data["discount_details"].map(d => ({
              id: d.value,
              name: d.name,
              barcode: d.barcode,
            }));
          } else if (this.discount.inclusion_type === "I" && this.discount.mapping_type === "C") {
            this.include_item = 3;
          } else if (this.discount.inclusion_type === "E" && this.discount.mapping_type === "P") {
            this.include_item = 4;
            this.excludedProductItems = this.discount.discount_details.map(d => d.value);
            this.excludedProductItemDetails = discount_data["discount_details"].map(d => ({
              id: d.value,
              name: d.name,
              barcode: d.barcode,
            }));
          } else if (this.discount.inclusion_type === "E" && this.discount.mapping_type === "C") {
            this.include_item = 5;
          }

          // if (this.discount.allowed_payment_types_id == null) {
          //   this.discount.allowed_payment_types_id = [];
          // } else {
          //   this.discount.allowed_payment_types_id = this.discount.allowed_payment_types_id;
          // }

          // this.discount.allowed_payment_types_id.forEach(async (value) => {
          //   if (value !== this.allPaymentTypeId) {
          //     let payment_type = await HTTPRequest.getRequest(
          //       component_x.endPoint + "payment_types/" + value,
          //       null
          //     );
          //     this.payment_types.push({
          //       id: payment_type.id,
          //       name: payment_type.name,
          //       disabled: false,
          //     });
          //   }
          // });
        } else {
          this.errors = discount_data["error"].split(",");
        }
      }
    }
    // loading false
    this.fetching = false;
    this.dynamicFormKey++;
  },
  data: function () {
    // this.handlePaymentTypeSearch = _.debounce(this.handlePaymentTypeSearch, 800);
    // this.handleProductSearch = _.debounce(this.handleProductSearch, 800);
    return {
      is_system: false,
      errors: [],

      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      discountId: 0,
      discount: {
        name: "",
        code: "",
        status: "A",
        discount_type: "OVA",
        min_amount_requirement: 0,
        max_discount_amount: null,
        rate_type: "P",
        rate: 0,
        site_ids: [],
        transaction_type_ids: [],
        subsegment_ids: [],
        is_supervisor_edit: false,
        start_date: null,
        end_date: null,
        days_availability: [],
        sequence_no: 0,
        is_allowed_with_ova_disc: false,
        is_allowed_with_gov_disc: false,
        is_allowed_with_item_disc: false,
        is_print_approval_copy: false,
        bypass_discount_recalculation: false,
        discount_category: null
      },
      dateRange: [null, null],
      siteOptions: [],
      transactionTypeOptions: [],
      subsegmentOptions: [],
      dayOptions: [
        { label: "Monday", value: 1 },
        { label: "Tuesday", value: 2 },
        { label: "Wednesday", value: 3 },
        { label: "Thursday", value: 4 },
        { label: "Friday", value: 5 },
        { label: "Saturday", value: 6 },
        { label: "Sunday", value: 7 },
      ],
      checkedDays: [],
      productList: [],
      products: [],
      formErrors: [],
      payment_types: [],
      all_payments: null,
      fetching: false,
      lastFetchId: 0,
      authHeaders: {
        Authorization: "Bearer " + secureStorage.getItem("accessToken"),
        "Access-Control-Allow-Origin": "*",
        "Request-Source": "BXI-File",
      },
      viewMode: this.$attrs.viewMode,
      filterCaption: "Search by Name",
      searchTextForFreeItem: '',
      uploadFile: null,
      categoriesOptions: [],
      inputCategory: [],
      inputExcludedCategory: [],
      selectedItemProductData: [],
      excludedItemProductData: [],
      selectedProductItem: [],   
      excludedProductItems: [], 
      selectedProductItemDetails: [],  
      excludedProductItemDetails: [],  
      includedCategories: [],
      excludedCategories: [],
      openUploadProductsDrawer: false,
      isProcessing: false,
      include_item: 1,
      apply_to_all: false,
      viewOnly: false,
      cachedAllProducts: [],
      filterField: "name",
      isLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false,
      },
      productSelectionColumns: [
        { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
        { title: 'Product Name', dataIndex: 'name', key: 'name' },
        {
          title: 'Action',
          key: 'action',
          scopedSlots: { customRender: 'action' } // 👈 required for slot
        }
      ],
      productItemColumns: [
        { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
        { title: 'Product Name', dataIndex: 'name', key: 'name' }
      ],
      includeItemOptions: [
        {key: 1, value: "All Items"},
        {key: 2, value: "Select Specific Items"},
        {key: 3, value: "Select Specific Category"},
        {key: 4, value: "Exclude Specific Items"},
        {key: 5, value: "Exclude Specific Categories"}
      ],
      categoryColumns: [
      {
        title: "Cateory ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Category Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Action",
        key: "action",
        scopedSlots: { customRender: "action" }
      }
    ]
    };
  },
  watch: {
    "discount.transaction_type_ids": (new_value, old_value) => {
      // added transaction types
      let new_transaction_types = _.difference(new_value, old_value);
      new_transaction_types.forEach(async (value) => {
        let new_subsegments = await HTTPRequest.getRequest(
          component_x.endPoint +
            "pos_sub_segments/get_valid_pos_sub_segments?pos_transaction_type_id=" +
            value,
          null
        );
        component_x.subsegmentOptions = component_x.subsegmentOptions.concat(
          new_subsegments
        );
      });

      // removed transaction types
      let removed_transaction_types = _.difference(old_value, new_value);
      let subsegment_ids_to_remove = _.flatMap(removed_transaction_types, (value) => {
        return component_x.subsegmentOptions
          .filter((x) => x.pos_transaction_type_id == value)
          .map((x) => x.id);
      });
      component_x.subsegmentOptions = component_x.subsegmentOptions.filter(
        (x) => !removed_transaction_types.includes(x.pos_transaction_type_id)
      );
      component_x.discount.subsegment_ids = component_x.discount.subsegment_ids.filter(
        (x) => !subsegment_ids_to_remove.includes(x)
      );
    },
    selectedItemProductData() {
      this.$forceUpdate()
    },
    excludedItemProductData() {
      this.$forceUpdate()
    },
    searchTextForFreeItem: _.debounce(function () {
      this.allProductsDataForIncludedItem(1);
    }, 500),
    include_item(newVal) {
      if (newVal === 1) { 
        this.handleIncludeAllProducts();
      }
    },
  },
  methods: {
    // csv import  methods
    toggleUploadProductsDrawer(bool) {
      this.openUploadProductsDrawer = bool;
    },
    setUploadFile(file) {
      this.uploadFile = file;
      this.$notification["success"]({
        message: "CSV File Selected",
        description: `${file.name} ready for upload.`,
      });
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.bagger;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;
      if (this.customFormMode == 3) {
        this.errors = errors;
      }
      this.bagger = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    removeSelectedCategory(id) {
      this.inputCategory = this.inputCategory.filter(c => c !== id);
    },
    removeExcludedCategory(id) {
      this.inputExcludedCategory = this.inputExcludedCategory.filter(c => c !== id);
    },
    validateForm() {
      this.errors = [];
      this.errors.push(ValidateField.charMinAndMax("Code", this.discount.code, 0, 20));
      this.errors.push(ValidateField.required("Name", this.discount.name));
      this.errors.push(ValidateField.charMinAndMax("Name", this.discount.name, 0, 50));
      this.errors.push(ValidateField.decimalFormat("Rate", this.discount.rate));
      this.errors.push(ValidateField.greaterThanZero("Rate", this.discount.rate));
      // this.errors.push(
      //   ValidateField.requiredButAllowZero("Sequence Number", this.discount.sequence_no)
      // );
      
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName("ant-drawer-wrapper-body")[0].scrollTop = 0;
      return this.errors.length;
    },
    // getSelectedPaymentType(value) {
    //   this.discount.allowed_payment_types_id = value;
    // },
    // handlePaymentTypeSearch(value) {
    //   this.fetching = true;
    //   this.lastFetchId += 1;
    //   const fetchId = this.lastFetchId;

    //   fetch(this.endPoint + `payment_types?name=${value}`, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: "Bearer " + secureStorage.getItem("accessToken"),
    //       "Access-Control-Allow-Origin": "*",
    //       "Request-Source": "BXI-Web",
    //     },
    //   })
    //     .then((res) => res.json())
    //     .then((res) => {
    //       if (fetchId !== this.lastFetchId) {
    //         // for fetch callback order
    //         return;
    //       }

    //       this.payment_types = res.data.map((value) => {
    //         return {
    //           id: value.id,
    //           name: value.name,
    //           disabled: false,
    //         };
    //       });

    //       // this.payment_types.unshift({id: 0, name: ' All Payment Types'})
    //       this.fetching = false;
    //     });
    // },
    create: async function () {
      if (this.isProcessing) return; 
      this.isProcessing = true; 
      try {
        if (!this.validateForm()) {
          this.discount.name = this.discount.name.trim();
          if (this.discount.code != undefined)
            this.discount.code = this.discount.code.trim();
          this.discount.status = "A";
          this.discount.start_date = moment(this.dateRange[0]).format("YYYY-MM-DD");
          this.discount.end_date = moment(this.dateRange[1]).format("YYYY-MM-DD");
          this.discount.days_availability = this.checkedDays;
          // this.discount.discount_category = this.discount.discount_category;

          this.discount.include_item_option = this.include_item;
          this.discount.included_categories = this.include_item == 3 ? this.inputCategory : [];
          this.discount.excluded_categories = this.include_item == 5 ? this.inputExcludedCategory : [];
          this.discount.apply_to_all = this.include_item === 1;

          let discount_details_attributes = [];
          let inclusion_type = "I";
          let mapping_type = "P";

          if (this.include_item === 1) {
            inclusion_type = null;
            mapping_type = null;   
          } else if (this.include_item === 2) {
            inclusion_type = "I";
            mapping_type = "P";            
            discount_details_attributes  = this.selectedProductItem.map(p => ({
              value: p,
            }));
          } else if (this.include_item === 3 && this.inputCategory.length > 0) {
            inclusion_type = "I";
            mapping_type = "C";
            discount_details_attributes  = this.inputCategory.map(c => ({
              value: c,
            }));
          } else if (this.include_item === 4) {
            inclusion_type = "E";
            mapping_type = "P";
            discount_details_attributes  = this.excludedProductItems.map(p => ({
              value: p
            }));
          } else if (this.include_item === 5 && this.inputExcludedCategory.length > 0) {
            inclusion_type = "E";
            mapping_type = "C";
            discount_details_attributes  = this.inputExcludedCategory.map(c => ({
              value: c,
            }));
          }

          this.discount.inclusion_type = inclusion_type;
          this.discount.mapping_type = mapping_type;
          this.discount.discount_details_attributes = discount_details_attributes;

          const formData = new FormData();
          Object.keys(this.discount).forEach(key => {
            const value = this.discount[key];
            if (Array.isArray(value) || typeof value === "object") {
              formData.append(`discount[${key}]`, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
              formData.append(`discount[${key}]`, value);
            }
          });

          if (this.uploadFile) {
            formData.append("file", this.uploadFile);
          }

          const post_request = await axios.post(
            `${this.endPoint}discounts`,
            formData,
            {
              headers: {
                Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                "Content-Type": "multipart/form-data",
                "Request-Source": "BXI-File"
              }
            }
          );
          if (post_request.status === 200) {
            this.$emit("refreshPage", event);
            if (this.uploadFile){
              this.$notification['success']({
                message: 'Ongoing Upload',
                duration: 0,
                description: "There's an ongoing upload of CSV file for this Discount. Click 'View Jobs' to review.",
                btn: h => {
                  return h(
                  'base-button',
                  {
                    props: {
                    type: 'success',
                    class: 'btn-sm',
                    },
                    on: {
                    click: () => component_x.$router.push("/jobs"),
                    },
                  },
                  'View Jobs',
                  );
                },
              });
            } else {
              this.$notification["success"]({
                message: "Success",
                description: "Discount successfully created.",
              });
            }
          }
        }
      } catch (error) {
        console.error("Create error:", error);
        this.$notification["error"]({
          message: "Error",
          description: "An error occurred while creating the discount.",
        });
      } finally {
        this.isProcessing = false;
      }
    },
    update: async function () {
      if (this.isProcessing) return; 
      this.isProcessing = true; 
      try {
        if (!this.validateForm()) {
          this.discount.name = this.discount.name.trim();
          if (this.discount.code != undefined)
            this.discount.code = this.discount.code.trim();
          this.discount.status = "A";

          this.discount.start_date = moment(this.dateRange[0]).format("YYYY-MM-DD");
          this.discount.end_date = moment(this.dateRange[1]).format("YYYY-MM-DD");
          this.discount.days_availability = this.checkedDays;
          // this.discount.discount_category = this.discount.discount_category;

          this.discount.include_item_option = this.include_item;
          this.discount.included_categories = this.include_item == 3 ? this.inputCategory : [];
          this.discount.excluded_categories = this.include_item == 5 ? this.inputExcludedCategory : [];
          this.discount.apply_to_all = this.include_item === 1;

          let discount_details_attributes = [];
          let inclusion_type = "I";
          let mapping_type = "P";

          if (this.include_item === 1) {
            inclusion_type = null;
            mapping_type = null;   
          } else if (this.include_item === 2) {
            inclusion_type = "I";
            mapping_type = "P";            
            discount_details_attributes  = this.selectedProductItem.map(p => ({
              value: p,
            }));
          } else if (this.include_item === 3 && this.inputCategory.length > 0) {
            inclusion_type = "I";
            mapping_type = "C";
             discount_details_attributes  = this.inputCategory.map(c => ({
              value: c,
            }));
          } else if (this.include_item === 4) {
            inclusion_type = "E";
            mapping_type = "P";
            discount_details_attributes  = this.excludedProductItems.map(p => ({
              value: p
            }));
          } else if (this.include_item === 5 && this.inputExcludedCategory.length > 0) {
            inclusion_type = "E";
            mapping_type = "C";
             discount_details_attributes  = this.inputExcludedCategory.map(c => ({
              value: c,
            }));
          }
          
          this.discount.inclusion_type = inclusion_type;
          this.discount.mapping_type = mapping_type;
          this.discount.discount_details_attributes = discount_details_attributes;
          delete this.discount.discount_details;

          const formData = new FormData();  
          Object.keys(this.discount).forEach(key => {
            const value = this.discount[key];
            if (Array.isArray(value) || typeof value === "object") {
              formData.append(`discount[${key}]`, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
              formData.append(`discount[${key}]`, value);
            }
          });

          if (this.uploadFile) {
            formData.append("file", this.uploadFile);
          }

          const put_request = await axios.put(
            `${this.endPoint}discounts/${this.profileId}`,
            formData,
            {
              headers: {
                Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                "Content-Type": "multipart/form-data",
                "Request-Source": "BXI-File"
              }
            }
          );

          if (put_request.status === 200) {
            this.$emit("refreshPage", event);
            if (this.uploadFile){
              this.$notification['success']({
                message: 'Ongoing Upload',
                duration: 0,
                description: "There's an ongoing upload of CSV file for this Discount. Click 'View Jobs' to review.",
                btn: h => {
                  return h(
                  'base-button',
                  {
                    props: {
                    type: 'success',
                    class: 'btn-sm',
                    },
                    on: {
                    click: () => component_x.$router.push("/jobs"),
                    },
                  },
                  'View Jobs',
                  );
                },
              });
            } else {
              this.$notification["success"]({
                message: "Success",
                description: "Discount successfully updated.",
              });
            }
          }
        }
      } catch (error) {
        this.$notification["error"]({
          message: "Error",
          description: "An error occurred while updating the discount.",
        });
      } finally {
        this.isProcessing = false;
      }
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    selectDaysAvail(day) {
      if (this.checkedDays.includes(day)) {
        var dayIndex = this.checkedDays.indexOf(day);
        this.checkedDays.splice(dayIndex, 1);
      } else {
        this.checkedDays.push(day);
      }

      this.checkedDays.sort((a, b) => a - b);
    },
    changeFilter(value){
        this.filterField = value
        this.filterCaption = "Filter By " + _.startCase(this.filterField);
        this.searchTextForFreeItem = '';
        this.allProductsDataForIncludedItem(1); 
    },
    async allProductsDataForIncludedItem(page = 1) {
      this.isLoading = true;
      try {
        const params = {
          page,
          per_page: this.pagination.pageSize,
          [this.filterField]: this.searchTextForFreeItem || ""
        };

        const query = new URLSearchParams(params).toString();
        const res = await HTTPRequest.getRequest(
          `${this.endPoint}products?${query}`,
          {
            headers: {
              Authorization: "Bearer " + secureStorage.getItem("accessToken"),
              "Request-Source": "BXI-Web"
            }
          }
        );
       if (this.include_item === 2) {
          this.selectedItemProductData = res.data || [];
          this.pagination.total = res.total;
          this.pagination.pageSize = res.per_page;
          this.pagination.current = res.current_page;
          const mergedDetails = [...this.selectedProductItemDetails];
          this.selectedItemProductData.forEach(prod => {
              if (this.selectedProductItem.includes(prod.id)) {
                const exists = mergedDetails.find(item => item.id === prod.id);
                if (!exists) {
                  mergedDetails.push({
                    id: prod.id,
                    name: prod.name,
                    barcode: prod.barcode
                  });
                }
              }
          });
       } else if (this.include_item === 4) {
          this.excludedItemProductData = res.data || [];
          this.pagination.total = res.total;
          this.pagination.pageSize = res.per_page;
          this.pagination.current = res.current_page;
          const mergedDetails = [...this.excludedProductItemDetails];
          this.excludedItemProductData.forEach(prod => {
            if (this.excludedProductItems.includes(prod.id)) {
              const exists = mergedDetails.find(item => item.id === prod.id);
              if (!exists) {
                mergedDetails.push({
                  id: prod.id,
                  name: prod.name,
                  barcode: prod.barcode
                });
              }
            }
          });
       }

      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        this.isLoading = false;
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.allProductsDataForIncludedItem(pagination.current);
    },
    handleSearch() {
      this.pagination.current = 1; 
      this.allProductsDataForIncludedItem(1);
    },
    async getProducts() {
      this.isLoading = true;
      try {
        const res = await HTTPRequest.getRequest(this.endPoint + "products?all=0", {
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Request-Source": "BXI-Web",
          },
        });
        this.selectedItemProductData = res.data || [];
        this.excludedItemProductData = res.data || [];
        this.pagination.total = (res.meta && res.meta.total) ? res.meta.total : this.selectedItemProductData.length;
        this.pagination.total = (res.meta && res.meta.total) ? res.meta.total : this.excludedItemProductData.length;
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.isLoading = false;
      }
    },
    selectIncludeProductItem(record) {
      const value = Number(record.value || record.id)
      if (this.selectedProductItem.includes(value)) {
        // remove from list
        this.selectedProductItem = this.selectedProductItem.filter(id => id !== value);
        this.selectedProductItemDetails = this.selectedProductItemDetails.filter(item => item.id !== value);
      } else {
        // add to list
        this.selectedProductItem.push(value);
        this.selectedProductItemDetails.push({
          id: value,
          name: record.name,
          barcode: record.barcode
        });
      }
      this.selectedProductItem = [...this.selectedProductItem]
      this.selectedProductItemDetails = [...this.selectedProductItemDetails]
    },
    selectExcludeProductItem(record) {
      const value = Number(record.value || record.id)
      if (this.excludedProductItems.includes(value)) {
        // remove from list
        this.excludedProductItems = this.excludedProductItems.filter(id => id !== value);
        this.excludedProductItemDetails = this.excludedProductItemDetails.filter(item => item.id !== value);
      } else {
        // add to list
        this.excludedProductItems.push(value);
        this.excludedProductItemDetails.push({
          id: value,
          name: record.name,
          barcode: record.barcode
        });
      }
      this.excludedProductItems = [...this.excludedProductItems];
      this.excludedProductItemDetails = [...this.excludedProductItemDetails];
    },
    async handleIncludeAllProducts() {
      // make it empty if All Items is selected from include items option
      this.selectedProductItem = []; 
      this.selectedProductItemDetails = [];
    },
    addAllFromIncludedList: async function (){
      let page = 1;
      this.isLoading = true;

      const params = {
        page,
        per_page: this.pagination.pageSize,
        [this.filterField]: this.searchTextForFreeItem || ""
      };
      const query = new URLSearchParams(params).toString();
      const all_products = await HTTPRequest.getRequest(
        `${this.endPoint}products?${query}`,
        {
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Request-Source": "BXI-Web"
          }
        }
      );

      let last_page = all_products.last_page
      if(all_products.last_page == 1){
        let array = all_products.data
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (this.selectedProductItem.includes(element.id) == false){
            this.selectedProductItem.push(element.id)
            this.selectedProductItemDetails.push({
              id: element.id,
              name: element.name,
              barcode: element.barcode
            })
          }
        }

        this.pagination.total = all_products.total;
        this.pagination.pageSize = all_products.per_page;
        this.pagination.current = all_products.current_page;

      } else if(all_products.last_page > 1){
        let array = all_products.data
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (this.selectedProductItem.includes(element.id) == false){
            this.selectedProductItem.push(element.id)

            this.selectedProductItemDetails.push({
              id: element.id,
              name: element.name,
              barcode: element.barcode
            })
          }
        }

        for (let i = 2; i < all_products.last_page + 1; i++) {
          const params = {
              page: i,
              per_page: this.pagination.pageSize,
              [this.filterField]: this.searchTextForFreeItem || ""
            };

            const query = new URLSearchParams(params).toString();

            const loop_products = await HTTPRequest.getRequest(
              `${this.endPoint}products?${query}`,
              {
                headers: {
                  Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                  "Request-Source": "BXI-Web"
                }
              }
            );
          let array = loop_products.data || [];
          for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (this.selectedProductItem.includes(element.id) == false){
              this.selectedProductItem.push(element.id)
              this.selectedProductItemDetails.push({
                id: element.id,
                name: element.name,
                barcode: element.barcode
              })
            }
          }
        }

        this.pagination.total = all_products.total;
        this.pagination.pageSize = all_products.per_page;
        this.pagination.current = all_products.current_page;
      }
      this.isLoading = false;

      // setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
      setTimeout(() =>  200)
    },
    addAllFromExcludedList: async function (){
      let page = 1;
      this.isLoading = true;

      const params = {
        page,
        per_page: this.pagination.pageSize,
        [this.filterField]: this.searchTextForFreeItem || ""
      };
      const query = new URLSearchParams(params).toString();
      const all_products = await HTTPRequest.getRequest(
        `${this.endPoint}products?${query}`,
        {
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Request-Source": "BXI-Web"
          }
        }
      );

      let last_page = all_products.last_page
      if(all_products.last_page == 1){
        let array = all_products.data
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (this.excludedProductItems.includes(element.id) == false){
            this.excludedProductItems.push(element.id)
            this.excludedProductItemDetails.push({
              id: element.id,
              name: element.name,
              barcode: element.barcode
            })
          }
        }

        this.pagination.total = all_products.total;
        this.pagination.pageSize = all_products.per_page;
        this.pagination.current = all_products.current_page;

      } else if(all_products.last_page > 1){
        let array = all_products.data
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (this.excludedProductItems.includes(element.id) == false){
            this.excludedProductItems.push(element.id)

            this.excludedProductItemDetails.push({
              id: element.id,
              name: element.name,
              barcode: element.barcode
            })
          }
        }

        for (let i = 2; i < all_products.last_page + 1; i++) {
          const params = {
              page: i,
              per_page: this.pagination.pageSize,
              [this.filterField]: this.searchTextForFreeItem || ""
            };

            const query = new URLSearchParams(params).toString();

            const loop_products = await HTTPRequest.getRequest(
              `${this.endPoint}products?${query}`,
              {
                headers: {
                  Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                  "Request-Source": "BXI-Web"
                }
              }
            );
          let array = loop_products.data || [];
          for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (this.excludedProductItems.includes(element.id) == false){
              this.excludedProductItems.push(element.id)
              this.excludedProductItemDetails.push({
                id: element.id,
                name: element.name,
                barcode: element.barcode
              })
            }
          }
        }

        this.pagination.total = all_products.total;
        this.pagination.pageSize = all_products.per_page;
        this.pagination.current = all_products.current_page;
      }
      this.isLoading = false;

      // setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
      setTimeout(() =>  200)
    },

    async loadCategories() {
      try {
        const data = await HTTPRequest.getRequest(
          this.endPoint + "categories/get_valid_categories?level=4",
          null
        );
        this.categoriesOptions = data;
      } catch (error) {
        console.error("Failed to load categories:", error);
        this.$notification["error"]({
          message: "Error",
          description: "Unable to load categories list.",
        });
      }
    },
    async filter(inputValue) {
      if (inputValue.length >= 3) {
        this.categoriesOptions = await HTTPRequest.getRequest(
          this.endPoint + "categories/cascader_view?name=" + inputValue,
          null
        );
      }
    },
  },
};
</script>

<style scoped>
 .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    overflow: hidden;
  }
  #free-item-product-table {
    background-color: #f5f5f5;
    border-radius: 6px;
    padding: 10px;
  }
  .tabulator-row:nth-child(even) {
    background-color: #f8f9fa !important;
  }
</style>
